import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import * as moment from 'moment';
import * as queryString from 'query-string';
import { ApilistService } from '../services/apilist.service';
import { CommonService } from '../services/common.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-materialpayment',
  standalone: true,
  imports: [
    CommonModule, // ✅ for *ngIf, *ngFor, ngStyle
    FormsModule, // ✅ for [(ngModel)]
    ReactiveFormsModule, // ✅ for reactive forms
  ],
  templateUrl: './materialpayment.component.html',
  styleUrls: ['./materialpayment.component.scss'],
})
export class MaterialpaymentComponent implements OnInit {
  paymentForm: UntypedFormGroup = null;
  payment: any = null;
  constructor(
    public formBuilder: UntypedFormBuilder,
    public commonService: CommonService,
    private apiListService: ApilistService
  ) {
    this.paymentForm = formBuilder.group({
      admission_fees: [
        '',
        Validators.compose([Validators.required, Validators.nullValidator]),
      ],
      application_fees: [
        '',
        Validators.compose([Validators.required, Validators.nullValidator]),
      ],
    });
  }

  ngOnInit(): void {
    this.getPaymentSettings();
  }

  async getPaymentSettings() {
    let service = this.apiListService.getApiConfigs('paymenttype');
    this.payment = await this.commonService.invokeService(
      service[0].method,
      service[0].path,
      null
    );
    this.payment = this.payment?.data;
    this.getPaymentDetails();

    this.payment = this.payment.map((item) => {
      item['edit'] = false;
      return item;
    });
  }

  async updatePaymentSettings(p: any) {
    let service = this.apiListService.getApiConfigs('updatepaymenttype');

    await this.commonService.invokeService(service[0].method, service[0].path, {
      id: p.id,
      admission_fees: p.admission_fees,
      application_fees: p.application_fees,
    });

    this.getPaymentSettings();
  }

  paymentDetails: any = null;

  search: any = {
    phone_num: '',
  };

  tableColums: string[] = null;
  async getPaymentDetails() {
    let service = this.apiListService.getApiConfigs(
      'allmaterialsubscribeddetails'
    );

    this.paymentDetails = await this.commonService.invokeService(
      service[0].method,
      `${service[0].path}?${queryString.stringify(this.search)}`,
      null
    );

    this.paymentDetails = this.paymentDetails.data;

    this.paymentDetails.map((item) => {
      (item['start_date'] = moment(item['start_date']).format(
        'DD-MM-YYYY HH:mm:ss'
      )),
        (item['end_date'] = moment(item['end_date']).format(
          'DD-MM-YYYY HH:mm:ss'
        ));
    });

    this.tableColums = Object.keys(this.paymentDetails[0]);
  }

  downloadInvoice(data) {
    // console.log("Data", data.user_id, data.id);
    // let url = 'https://demo.emeetify.com:81/downloaduseradmissionform?user_id=${data.user_id}&id=${data.id}';
    let url =
      'https://smscap.in/api/downloadinvoice?receipt_id=' + data.receipt_id;
    // console.log(url);
    window.open(url);

    // this.commonservice.getMethod(`downloaduseradmissionform?user_id=${data.user_id}&id=${data.id}`, '')
    //   .then((resp: any) => {
    //     console.log("resp", resp);
    //     // this.downLoadFile(resp, "application/ms-excel");
    //   });
  }
}
